const light = {
  title: 'light',

  colors: {
    background: '#f8f8f8',
    text: '#000',

    asideBackground: '#835afd',
    asideColor: '#FFF',
    strongColor: '#f0f0f0',
    formInputBg: '#FFF',
    formInputBorder: '#a8a8b3',

    createRoomBackground: '#ea4335',
    createRoomColor: '#FFF',

    separatorColor: '#a8a8b3',
    separatorBefore: '#a8a8b3',
    separatorAfter: '#a8a8b3',

    pColor: '#737380',
    aColor: '#e559f9',

    questionBoxBg: '#ffff',
    highlighted: '#f4f0ff',
    answered: '#dbdcdd',
  }
}

export default light;